import React from 'react'

export const CreateCompanyRegisterPage = () => {
  return (
    <div>CreateCompanyRegisterPage</div>
  )
}
